import { Info } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

interface UserPermissionsTabProps {
  userId: string;
}

export function UserPermissionsTab({ userId: _userId }: UserPermissionsTabProps) {
  void _userId;
  return (
    <div className="space-y-6">
      <Card className="border-blue-200 bg-blue-50">
        <CardContent className="p-4 flex items-start gap-3">
          <Info className="h-5 w-5 text-blue-600 mt-0.5 flex-shrink-0" />
          <div>
            <p className="font-medium text-blue-900">Direct User Permissions</p>
            <p className="text-sm text-blue-700 mt-1">
              This feature allows direct permission assignment to individual users, overriding role-based permissions.
              Currently, this user inherits all permissions from their assigned roles.
            </p>
            <div className="mt-3">
              <Badge variant="outline" className="bg-white">
                Coming in Phase 2
              </Badge>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-12 text-center">
          <div className="text-muted-foreground">
            <p className="text-lg font-medium">User-specific permissions not configured</p>
            <p className="text-sm mt-2">
              This user currently has permissions based on their role assignments.
              <br />
              Check the "Roles" tab to manage role-based permissions.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
